import { Component, inject } from '@angular/core';
import { EnvironmentService } from 'src/app/core/environment.service';
import { TranslateModule } from '@ngx-translate/core';
import { SetPasswordPageComponent } from '../../components/set-password-page/set-password-page.component';
import { NgClass } from '@angular/common';
import { LogoComponent } from '@app/shared/components/logo/logo.component';

@Component({
  selector: 'app-set-password-page-container',
  templateUrl: './set-password-page-container.component.html',
  styleUrls: ['./set-password-page-container.component.scss'],
  imports: [SetPasswordPageComponent, NgClass, TranslateModule, LogoComponent],
})
export class SetPasswordPageContainerComponent {
  env = inject(EnvironmentService);
}
